<template>
  <div class="landingpage_navigation">
    <div class="landingpage_navigation_container">
      <ul>
        <li>
          <a
            href="#"
            @click.prevent="scrollTo('.why_vivense_wrapper')"
            class="navigation_item navigation_item_why_vivense"
            :class="itemsClasses('whyVivense')"
          >
            Neden Vivense?
          </a>
        </li>
        <li>
          <a
            href="#"
            @click.prevent="scrollTo('.how_it_work')"
            class="navigation_item navigation_item_how_it_work"
            :class="itemsClasses('howItWork')"
          >
            Nasıl Çalışır?
          </a>
        </li>
        <li>
          <a
            href="#"
            @click.prevent="scrollTo('.what_i_can_sell')"
            class="navigation_item navigation_item_what_i_can_sell"
            :class="itemsClasses('whatCanISell')"
          >
            Neler Satabilirim?
          </a>
        </li>
        <li>
          <a
            href="#"
            @click.prevent="scrollTo('.faq_wrapper')"
            class="navigation_item navigation_item_faq_wrapper"
            :class="itemsClasses('faq')"
          >
            Sık Sorulan Sorular
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeSectionNavigation',
  props: {
    activeSection: {
      type: String,
      default: null,
    },
  },
  methods: {
    itemsClasses(itemName) {
      return {
        active: this.activeSection === itemName,
      };
    },
    scrollTo(el) {
      this.$scrollTo(el);
    },
  },
};
</script>
